import { css } from "@emotion/react"
import { Button, Modal, Typography } from "matsuri-ui"
import { useState } from "react"
import { useTranslation } from "@/hooks/useTranslation"

export interface ConfirmApproveAllDialogProps {
    onAccept: () => Promise<void>
    onClose: () => void
}

export const ConfirmApproveAllDialog = ({
    onAccept,
    onClose,
    ...props
}: ConfirmApproveAllDialogProps) => {
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(false)

    const handleAccept = async () => {
        if (isLoading) return
        setIsLoading(true)
        try {
            await onAccept()
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal
            {...props}
            body={
                <>
                    <Typography variant="h3" as="h3">
                        {t("一括で承認する")}
                    </Typography>
                    <Typography
                        css={css`
                            margin-top: 8px;
                        `}
                    >
                        {t("タスクを一括で承認します。よろしいですか？")}
                    </Typography>
                </>
            }
            footer={
                <footer
                    css={css`
                        display: flex;
                        gap: 8px;
                        justify-content: flex-end;
                    `}
                >
                    <Button variant="text" onClick={onClose}>
                        {t("戻る")}
                    </Button>
                    <Button
                        variant="filled"
                        color="primary"
                        onClick={handleAccept}
                        disabled={isLoading}
                        loading={isLoading}
                    >
                        {t("一括で承認する")}
                    </Button>
                </footer>
            }
        />
    )
}
